<template>
    <div class="guestpicker-container">

        <div class="row">
            <div v-if="!hideChrome" class="col-12">
                <div class="picker-title">{{companionsPicker_Title_ChooseCompany}}</div>

            </div>
            <div class="col-lg-12 pickers">
                <amount-picker v-model="model.numberOfAdults"
                               name="NumberOfPersons"
                               :label="companionsPicker_Label_NumberOfPersons"
                               :max="maxGuests"
                               :min="1"></amount-picker>

                <amount-picker v-model="model.numberOfBabies"
                               name="NumberOfBabies"
                               :label="companionsPicker_Label_NumberOfBabies"
                               :max="8"
                               :sub-label="companionsPicker_Title_Between_0_2_years"></amount-picker>

                <amount-picker v-model="model.numberOfPets"
                               v-show="maxPets>0"
                               :max="maxPets"
                               :label="companionsPicker_Label_NumberOfPets"
                               name="NumberOfPets"></amount-picker>
            </div>
        </div>
      
        <div  v-if="!hideChrome" class="row">
            <br />
            <div class="col-lg-12 search">
                <button v-if="forceNoBtnType" class="btn-arrow--next"  @click="onConfirm">{{customButtonText}}</button>
                <button v-else class="btn-arrow--next" type="button" @click="onConfirm">{{customButtonText}}</button>
            </div>
        </div>


    </div>

</template>
<script src="./companionsPicker.ts"></script>
<style src="./styles.css"></style>
